// extracted by css-extract-rspack-plugin
export default {"parentIssuesList":"ParentIssueAddedEvent-module__parentIssuesList__IIFc4Rv","parentIssueItem":"ParentIssueAddedEvent-module__parentIssueItem__YqrZ2Ij"};